/** App route paths */
export const HOME = '/'
export const INDEX = '/index'

export const LOGIN = '/login'
export const LOGIN_DAILY_POINT = '/reward'
export const LOYALTY_POINTS = 'post/point'
export const REGISTER = '/register'
export const REGISTERS = '/registers'
export const SIGN_IN = '/sign-in'
export const FORGOT_PASSWORD = '/fogot-password'
export const CHANGE_PASSWORD = '/change-password'
export const PASSWORD = '/password'

export const DASHBOARD = '/dashboard'
export const INFORM = '/inform'
export const CONTACT = '/contact'

export const CREATE_NEWS = '/create-news'
export const POST_MANAGER = '/post-manager'
export const ROOM_MANAGER = '/building/rooms'
export const POST_NEWS_CREATE = '/post/create'
export const CUSTOMER_POST_NEWS = '/posts'
export const CUSTOMER_SETTING_ACCOUNT = '/post/setting'

export const PRODUCTS = '/products'
export const PRODUCT_DETAIL = '/products-detail'
export const SEARCH = '/search'
export const CART = '/cart'
export const ORDERS = '/orders'
export const FAVOURITE = '/favourite'
export const FINISHS = '/finishs'

export const NEWS = '/news'
export const NEWS_DETAIL = '/news-detail'
export const COLLECTIONS = '/collections'
export const RULES = '/rules'

export const SCANS = '/scans'
export const SERVICES = '/services'

export const HOW_TO_ORDER = '/how-to-order'
export const PAYMENT_GUIDE = '/payment-guide'
export const FAQ_PATH = '/faq'
export const WARRANTY_GUIDE = '/warranty-guide'
export const ABOUT = '/about'
export const STORES = '/stores'
export const RETURN_POLICY = '/return-policy'
export const SHIPPING_POLICY = '/shipping-policy'
export const DELIVERY_POLICY = '/delivery-policy'
export const CAREERS = '/careers'

export const productDetailPath = (id: string | number) => `${PRODUCT_DETAIL}/${id}`
export const newsDetailPath = (id: string | number) => `${NEWS_DETAIL}/${id}`
export const userProfilePath = (tag: string) => {
  const normalized = String(tag || '').trim().replace(/^@/, '')
  return normalized ? `/${encodeURIComponent(normalized)}` : HOME
}
